import { TabsNarrowContainer, TabsNarrowMain } from "../TabsView/styled";
import ImgProgressBar from "./ImgProgressBar";

const TabsViewNarrowLoader = () => {
	return (
		<>
			{/* @ts-ignore */}
			<TabsNarrowMain>
				{/* @ts-ignore */}
				<TabsNarrowContainer>
					<ImgProgressBar isNoBorder />
				</TabsNarrowContainer>
			</TabsNarrowMain>
		</>
	);
};

export default TabsViewNarrowLoader;
